import type { UserModel } from '@/stores/user'

import { AppAbility } from './AppAbility'
import type { UserAbility } from './AppAbility'

export const initialAbility: UserAbility[] = [
  { action: 'read', subject: 'Auth' },
]

/**
 * Derives CASL ability rules from the current user data.
 *
 * Prefers the structured `abilities` array from the server (single source of truth).
 * Falls back to the legacy bridge if the server response predates the RBAC rollout,
 * so a deploy ordering gap never locks out existing vector users.
 *
 * Fail-safe: an explicit empty `abilities: []` means no permissions (restricted user),
 * not "unrestricted". Only a missing key triggers the legacy bridge.
 */
export function buildAbilityRules(user: UserModel): UserAbility[] {
  if ('abilities' in user && Array.isArray(user.abilities)) {
    if (user.abilities.length === 0)
      console.warn('[CASL] abilities array is empty — user has no granted permissions')

    return user.abilities.length > 0 ? (user.abilities as UserAbility[]) : initialAbility
  }

  // Legacy bridge: server response predates abilities field
  console.warn('[CASL] /profile response missing abilities field — using legacy vector bridge')

  return user.access?.vector ? [{ action: 'manage', subject: 'all' }] : initialAbility
}

export default new AppAbility(initialAbility)
